import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=7e964800&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=7e964800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e964800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e964800')) {
      api.createRecord('7e964800', component.options)
    } else {
      api.reload('7e964800', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=7e964800&scoped=true&", function () {
      api.rerender('7e964800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h8Dha5MgiPrv/JS/comp/SearchFilterTokens.vue"
export default component.exports